import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const coprocessorSchema: Schema = {
  title: 'Coprocessor',
  level: 2,
  columns: commonColumns
}
